/**
 * BlogCategories.tsx — Gold Garage Door / Blog Hub · Section 3/4
 * Navy · thin category pills strip — quick filter/navigation for future blog posts.
 * MOBILE: real <style> media queries.
 * 10WEB AI: wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";
const CATS = [{
  name: "All Posts",
  href: "/blog/",
  active: true
}, {
  name: "Repairs",
  href: "/blog/?cat=repairs"
}, {
  name: "Installation",
  href: "/blog/?cat=installation"
}, {
  name: "Maintenance",
  href: "/blog/?cat=maintenance"
}, {
  name: "Brands",
  href: "/blog/?cat=brands"
}, {
  name: "Tips",
  href: "/blog/?cat=tips"
}, {
  name: "Safety",
  href: "/blog/?cat=safety"
}];
export default function BlogCategories() {
  return <section id="blog-categories" style={{
    background: `radial-gradient(ellipse at 50% 100%, #14254d 0%, ${NAVY} 55%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "4rem",
    paddingBottom: "4rem"
  }}>
      <style>{`@media (max-width: 560px) { #blog-categories { padding-top: 2.5rem; padding-bottom: 2.5rem; } }`}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}>
        <filter id="grain-blc"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#grain-blc)" />
      </svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />

      <div style={{
      maxWidth: "800px",
      margin: "0 auto",
      padding: "0 1.5rem",
      textAlign: "center",
      position: "relative",
      zIndex: 1
    }}>
        <span style={{
        fontFamily: "'Manrope', sans-serif",
        fontSize: "0.72rem",
        fontWeight: 700,
        letterSpacing: "0.16em",
        color: GOLD,
        textTransform: "uppercase",
        display: "block",
        marginBottom: "1.25rem"
      }}>Browse By Topic</span>

        <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "0.6rem",
        justifyContent: "center"
      }}>
          {CATS.map((c, i) => <a key={i} href={c.href} style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 700,
          fontSize: "0.88rem",
          color: c.active ? NAVY : "#fff",
          background: c.active ? GOLD : "rgba(255,255,255,0.08)",
          border: `1px solid ${c.active ? GOLD : "rgba(255,255,255,0.2)"}`,
          borderRadius: "999px",
          padding: "0.5rem 1.2rem",
          textDecoration: "none"
        }}>
              {c.name}
            </a>)}
        </div>

        <p style={{
        fontFamily: "'Manrope', sans-serif",
        fontSize: "0.88rem",
        color: "rgba(255,255,255,0.5)",
        marginTop: "1.5rem",
        lineHeight: 1.6
      }}>
          New posts coming regularly — practical garage door advice from the crew that does the work.
        </p>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}>
          <path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" />
        </svg>
      </div>
    </section>;
}